module.exports = __webpack_public_path__ + "img/astronaut_me.fff6d724.webp";